import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'dashboard',
    path: '/dashboard',
    component: () => import('@/pages/Dashboard/Dashboard.vue'),
    meta: buildMeta({
      pageTitle: 'Dashboard',
      title: 'Dashboard - Jobscan',
      liveChatEnabled: true,
    }),
  },
]

export default routes
